import { observer } from 'mobx-react-lite';
import { Outlet, useNavigate } from 'react-router-dom';
import {
  Box,
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Avatar,
} from '@mui/material';
import { useState } from 'react';
import { useAuthStore } from '../../stores/root_store';

export const AppLayout = observer(() => {
  const authStore = useAuthStore();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    handleClose();
    await authStore.logout();
    navigate('/login');
  };

  const userInitial = authStore.user?.first_name?.[0] ||
                      authStore.user?.primary_email?.[0]?.toUpperCase() ||
                      '?';

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      <AppBar position="static" color="default" elevation={1}>
        <Toolbar>
          <Box
            sx={{ flexGrow: 1, cursor: 'pointer', display: 'flex', alignItems: 'center' }}
            onClick={() => navigate(authStore.isAssistant ? '/assistant' : '/request')}
          >
            <img
              src="/Fancy-Hands-Logo.png"
              alt="Fancy Hands"
              style={{ height: 32 }}
            />
          </Box>

          {authStore.isClient && (
            <Button
              color="inherit"
              onClick={() => navigate('/request')}
              sx={{ mr: 1 }}
            >
              Dashboard
            </Button>
          )}

          {authStore.isAssistant && (
            <Button
              color="inherit"
              onClick={() => navigate('/assistant')}
              sx={{ mr: 1 }}
            >
              Assistant
            </Button>
          )}

          {authStore.user?.is_manager && (
            <Button
              color="inherit"
              onClick={() => navigate('/manager')}
              sx={{ mr: 1 }}
            >
              Manager
            </Button>
          )}

          <IconButton
            size="large"
            onClick={handleMenu}
            color="inherit"
          >
            <Avatar sx={{ width: 32, height: 32, bgcolor: 'primary.main' }}>
              {userInitial}
            </Avatar>
          </IconButton>
          <Menu
            id="menu-appbar"
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            keepMounted
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            <MenuItem disabled>
              <Typography variant="body2" color="text.secondary">
                {authStore.user?.primary_email}
              </Typography>
            </MenuItem>
            <MenuItem onClick={() => { handleClose(); navigate('/settings'); }}>
              Settings
            </MenuItem>
            <MenuItem onClick={handleLogout}>Sign Out</MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>

      <Outlet />
    </Box>
  );
});
